document.addEventListener('DOMContentLoaded', function () {
  const url = new URL(window.location.href);
  const path = url.pathname;
  const isCollection = path.includes('/collections/');
  const hasPaginationParam = url.searchParams.has('pagination');

  if (isCollection && hasPaginationParam) {
    // Remove pagination param and redirect
    url.searchParams.delete('pagination');

    // Optional: Also clean Shopify cursor if it ever shows up again
    url.searchParams.delete('phcursor');

    // Avoid redirect loop: only redirect if query string changed
    const cleanUrl = url.pathname + url.search;
    const currentFull = window.location.pathname + window.location.search;

    if (cleanUrl !== currentFull) {
      // Perform redirect
      window.location.replace(cleanUrl);
    }
  }
});